import { render, staticRenderFns } from "./SectionButtons.vue?vue&type=template&id=c057b6cc&scoped=true&"
import script from "./SectionButtons.vue?vue&type=script&lang=js&"
export * from "./SectionButtons.vue?vue&type=script&lang=js&"
import style0 from "./SectionButtons.vue?vue&type=style&index=0&id=c057b6cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c057b6cc",
  null
  
)

export default component.exports